import { useState } from 'react'
import { Card, CardHeader, CardBody, Button, Label, Input, FormFeedback, Alert, Spinner, Form, FormGroup, Row, Col } from 'reactstrap'
import useForm from '../CustomHooks/FormHook'
import { EXPORT_SCHEMA_MUTATION } from '../../graphql'
import { handleGraphQLErrors, dateTimeStamp, publishEvent, configValue } from '../../utils.js'
import { gql } from '@apollo/client'
import SchemaSelect from './SchemaSelect'
import DatapumpJobs from './DatapumpJobs'
import ExportHistory from './DatapumpHistory'

const EXPORT_SCHEMA = gql(EXPORT_SCHEMA_MUTATION)

export default function ExportSchema() {
  console.log('ExportSchema rendered')

  const directory = configValue('DEFAULT ORACLE DIRECTORY')
  const source = 'EXPORT_SCHEMA'
  const { inputs, handleInputChange } = useForm({ schemaName: '' }, handleSubmit)
  const [excludeFiles, setExcludeFiles] = useState(true)
  const [schemaNameState, setschemaNameState] = useState({ state: '', message: '' })
  const [spinner, setSpinner] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])

  async function handleSubmit() {
    console.log('ExportSchema.handleSubmit: ', inputs, { excludeFiles })
    setGraphQLErrors([])
    let state = null
    state = inputs.schemaName ? { state: '', message: '' } : { state: 'has-danger', message: 'Schema is required.' }
    setschemaNameState(state)

    if (inputs.schemaName) {
      setschemaNameState({ state: '', message: '' })
      const options = {}
      if (excludeFiles) {
        options.excludeFiles = true
      }
      options.jobName = `EXPORT:${inputs.schemaName}`
      setSpinner(true)
      try {
        const variables = { schemaName: inputs.schemaName, directoryName: directory, options: options }
        const { data, errors } = await window.apolloClient.mutate({ mutation: EXPORT_SCHEMA, variables: variables })
        console.log('export schema returned: ', data, errors)
        if (data.exportSchema) {
          const eventData = { jobName: options.jobName, operation: 'EXPORT', started: dateTimeStamp(), schema: inputs.schemaName, status: 'SUBMITTED', finish: '' }
          publishEvent(`${source}_DATAPUMP_JOB_SUBMITTED`, eventData, 'ExportSchema')
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        console.log(err)
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setSpinner(false)
      }
    }
  }

  let button =  <Button color="primary" onClick={handleSubmit}>Export Schema</Button>
  if (spinner) {
    button = <Button disabled color="primary"><Spinner size="sm" /> Submitting datapump job...</Button>
  }

  let cardBody = 
    <CardBody>
      <Alert color="danger" isOpen={graphQLErrors.length ? true : false}>{graphQLErrors.length ? graphQLErrors[0].message : ''}</Alert>
      <Form>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="schemaName">Schema</Label>
              <SchemaSelect
                inputName={'schemaName'}
                handleChange={handleInputChange}
                invalid={schemaNameState.state === 'has-danger'}
                valid={schemaNameState.state === 'has-success'}
              />
              <FormFeedback>{schemaNameState.message}</FormFeedback>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup switch>
              <Input 
                name={'excludeFiles'}
                checked={excludeFiles}
                onChange={() => { setExcludeFiles(!excludeFiles) }}
                type="switch"
                role="switch"
              />
              <Label check>Exclude files</Label>
            </FormGroup>
          </Col>
        </Row>
      </Form>
      <div style={{ paddingTop: '10px', textAlign: 'center' }}>
        {button}
      </div>
      <ExportHistory source="EXPORT_SCHEMA" />
      <DatapumpJobs source="EXPORT_SCHEMA" />
    </CardBody>

  return (
    <Card style={{ maxWidth: '700px', marginTop: '20px' }}>
      <CardHeader style={{ fontWeight: 'bold' }}>Export Schema</CardHeader>
      {cardBody}
    </Card>
  )
}
